import { Stack } from '@mui/material'
import {
  PositionDrawingFilterState,
  PositionDrawingFilters,
} from 'src/screens/admin/position-drawing/components/positionDrawingFilters'

interface ManageTemplatesDefaultFilterProps {
  drawingFilters: PositionDrawingFilterState
  onSearchChange: (value: string) => void
  onProductCategoriesChange: (categoryIds: EntityId[]) => void
}

export const ManageTemplatesDefaultFilter: React.FC<ManageTemplatesDefaultFilterProps> = ({
  drawingFilters,
  onSearchChange,
  onProductCategoriesChange,
}) => (
  <Stack spacing={1} sx={{ px: 1, pb: '3px' }}>
    <PositionDrawingFilters
      filters={drawingFilters}
      onSearchChange={onSearchChange}
      onProductCategoriesChange={onProductCategoriesChange}
      padding={0}
    />
  </Stack>
)
